import './helpers.js';
import { e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import './Icon-4445210d.js';
import 'vue';
import { s as script, a as script$1 } from './Pagination-d2715580.js';
export { s as OPagination, a as OPaginationButton } from './Pagination-d2715580.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
    registerComponent(Vue, script$1);
  }

};
use(Plugin);

export default Plugin;
